import React, { Fragment } from 'react';
import helpPageSectionsData from './HelpPageSectionsData';

function HelpPageSections({ slug, handleBugReportClick }) {
  if (slug) {
    const sectionData = helpPageSectionsData(handleBugReportClick).find(section => section.slug === slug);
    return (
      <div className="help__main text">
        <h2>{sectionData.title}</h2>
        {sectionData.subsections.map((subsection, i) => (
          <Fragment key={i}>
            {subsection.heading && <h3>{subsection.heading}</h3>}
            {subsection.content}
          </Fragment>
        ))}
      </div>
    );
  }
  // Otherwise return the default text
  return (
    <div className="help__main text">
      <h2>Welcome to the RTA MedSafety Tracer Tool Help Center</h2>
      <p>
        Choose a category to find the help you need, or
        {' '}
        <a href="mailto:help@rtamedsafety.com?subject=RTA MedSafety Help" target="_blank" rel="noopener noreferrer">
          email us
        </a>
        {' '}
        if you can’t find what you’re looking for.
      </p>
    </div>
  );
}

export default HelpPageSections;



// WEBPACK FOOTER //
// ./src/components/features/dashboard/HelpPageSections.js